import config from 'config';
import * as actionTypes from './actions';
export const initialState = {
    itemsPerPage: 10,
    currentPage: 1,
    paginationMeta: {
        currentPage: 1,
        itemCount: 10,
        itemsPerPage: 10,
        totalItems: 10,
        totalPages: 1
    },
    historyItems: {},
    historyShortList: {}
};
const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setItemsPerPage:
            return {
                ...state,
                itemsPerPage: action.itemsPerPage
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        case actionTypes.setPaginationMeta:
            return {
                ...state,
                paginationMeta: action.paginationMeta
            };
        case actionTypes.setHistoryItems:
            return {
                ...state,
                historyItems: action.historyItems
            };
        case actionTypes.setHistoryShortList:
            return {
                ...state,
                historyShortList: action.historyShortList
            };
        default:
            return state;
    }
};
export default customizationReducer;
